export function getMostFrequentNumber(arr: number[]): number {
  const count: Record<number, number> = {};

  // Подсчитываем частоту каждого числа
  for (const num of arr) {
    count[num] = (count[num] || 0) + 1;
  }

  // Находим число с максимальной частотой
  let maxCount = 0;
  let mostFrequent = 0;

  for (const num in count) {
    if (count[num] > maxCount) {
      maxCount = count[num];
      mostFrequent = Number(num);
    }
  }

  return mostFrequent;
}
